import { FC } from 'react'

import { Role, roleNameDictionary } from '@models/Role'
import { useAppSelector } from '@store/hooks'
import { selectRoleById } from '@store/RoleReducer'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { Typography } from 'antd'

const { Text } = Typography

type Props = SBModelComponent<Role> & {}

export const RoleAvatar: FC<Props> = ({ id, model }) => {
  const item = model ? model : useAppSelector(selectRoleById(id!))

  if (!item) {
    return <></>
  }

  return <Text>{roleNameDictionary[item.name]}</Text>
}

export type RoleAvatarType = { Avatar: typeof RoleAvatar }
